import { RAISE_MANUAL_FORM,MARK_MANUAL_FORM } from "../../utils/constants";


const initialState = [];

function vendorOrderReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case RAISE_MANUAL_FORM:
            return [...state, payload];
        case MARK_MANUAL_FORM:
            return [...state, payload];
            
        default:
            return state;
    }
};

export default vendorOrderReducer